<template>
  <HeadComponent :title="formattedTitle">
    <slot />
  </HeadComponent>
</template>

<script>
import {Head as HeadComponent} from '@inertiajs/vue3';

export default {
  components: {
    HeadComponent,
  },

  props: {
    title: {
      type: String,
      required: false,
      default: null,
    },
  },

  computed: {
    formattedTitle () {
      if (this.title) {
        return this.title.endsWith('| ShoutOut.vip') ? this.title : `${this.title} - ShoutOut VIP`;
      }
      return this.title ? `${this.title}` : 'ShoutOut VIP';
    },
  },
};
</script>
